import api from '../../api';
// 获取banner列表
export function getBanners(params) {
  return api.post('/banner/getBannerList.go', params, false, false).then(res => res);
}
// 新增产品
export function addBanner(params) {
  return api.post('/banner/addBanner.go', params).then(res => res);
}
// 新增产品
export function delBanner(params) {
  return api.post('/banner/delBanner.go', params).then(res => res);
}
// 新增产品
export function upBanner(params) {
  return api.post('/banner/upBanner.go', params).then(res => res);
}
// 获取产品详情
export function getProduct(params) {
  return api.post('/product/getProduct.go', params, false, false).then(res => res);
}
// 更新产品详情
export function upProduct(params) {
  return api.post('/product/upProduct.go', params).then(res => res);
}
// 产品删除
export function delProduct(params) {
  return api.post('/product/delProduct.go', params).then(res => res);
}
// 产品隐藏
export function hideBanner(params) {
  return api.post('/banner/hideBanner.go', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/banner.js